var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import MuiCircularProgress from '@material-ui/core/CircularProgress';
/**
 * Kareo wrapped component of the Material-UI CircularProgress. The prop API has been limited to props defined in CircularProgressProps.
 *
 * Circular progress indicators express an unspecified wait time or display the length of a process.
 *
 * Material-UI CircularProgress: [Docs](https://v4.mui.com/components/progress/), [API](https://v4.mui.com/api/circular-progress)
 *
 * @storybook: [CircularProgress](http://design.kareoprod.ent/design-system/?path=/story/components-feedback-progress--circular-progress-storybook)
 */
var CircularProgress = function (props) {
    return React.createElement(MuiCircularProgress, __assign({}, props));
};
CircularProgress.defaultProps = {};
export default CircularProgress;
